module.exports = __webpack_public_path__ + "img/redbagopen.fa979bd6.png";